// extracted by mini-css-extract-plugin
export var carousel = "HomeCarousel-module--carousel--SxC8K";
export var carousel_slide = "HomeCarousel-module--carousel_slide--AtepN";
export var carousel_slide_image = "HomeCarousel-module--carousel_slide_image--QVRnz";
export var carousel_slide_title = "HomeCarousel-module--carousel_slide_title--YifLE";
export var carousel_arrow_left = "HomeCarousel-module--carousel_arrow_left--zuBLt";
export var carousel_arrow_right = "HomeCarousel-module--carousel_arrow_right--EL2jP";